import CardList from "../components/Home/CardList"
import SearchBar from "../components/Home/SearchBar"

const HomePage = () => {
    return (
        <>
            <SearchBar />

            <CardList />
        </>
    )
}

export default HomePage